<template>
  <tr>
    <td>
      {{ columnName }}
    </td>
    <td>
      {{ notes }}
    </td>
    <td>
      {{ source }}
    </td>
    <td>
      {{ type }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'DataDictionaryCard',
  props: {
    entry: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    columnName: function () {
      return this.entry[0]
    },
    primaryTable: function () {
      return this.entry[1]
    },
    lookUp: function () {
      return this.entry[2]
    },
    source: function () {
      return this.entry[3]
    },
    type: function () {
      return this.entry[4]
    },
    notes: function () {
      return this.entry[5]
    }

  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DataDictionaryCard.vue